<ham-modal
    [title]="'aumico_d365bc_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onCancel()"
>
    <div class="d365bc-modal-body">
        <!-- Step 1: form -->
        <section *ngIf="step === 'welcome'">
            <p class="d365bc-modal-body__paragraph">
                {{ 'aumico_d365bc_step_welcome_intro' | i18next }}
            </p>

            <div class="d365bc-modal-body__field">
                <label for="displayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="displayName"
                    type="text"
                    [(ngModel)]="customDisplayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="d365bc-modal-body__hint">
                    {{ 'aumico_d365bc_step_config_displayname_help' | i18next }}
                </small>
            </div>

            <div class="d365bc-modal-body__field">
                <label for="environmentName">
                    {{ 'aumico_d365bc_step_config_environment_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="environmentName"
                    type="text"
                    [(ngModel)]="environmentName"
                    placeholder="production"
                />
                <small class="d365bc-modal-body__hint">
                    {{ 'aumico_d365bc_step_config_environment_help' | i18next }}
                </small>
            </div>

            <div class="d365bc-modal-body__actions">
                <ham-button
                    variant="primary"
                    size="sm"
                    [disabled]="!isFormValid"
                    (buttonClick)="onStartConsent()"
                >
                    {{ 'aumico_d365bc_step_welcome_signin_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!-- Step 2: Waiting for Microsoft consent (popup open) -->
        <section *ngIf="step === 'awaiting_consent'" class="d365bc-modal-body__loading">
            <div class="d365bc-modal-body__spinner"></div>
            <p class="d365bc-modal-body__paragraph">
                {{ 'aumico_d365bc_status_awaiting_consent' | i18next }}
            </p>
            <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                {{ 'aumico_button_cancel' | i18next }}
            </ham-button>
        </section>

        <!-- Step 3: Error -->
        <!-- Note: success has no view here. The popup already confirms success;
             this modal closes immediately and the mapping modal takes over. -->
        <section *ngIf="step === 'error'" class="d365bc-modal-body__error">
            <div class="d365bc-modal-body__error-icon">⚠</div>
            <h3 class="d365bc-modal-body__title">{{ 'aumico_integration_status_error_title' | i18next }}</h3>
            <p class="d365bc-modal-body__error-message">{{ errorMessage }}</p>
            <div class="d365bc-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
